import { BaseApi } from '@/main/baseApi';

import { NAME, DMS_MODULE } from './constants';


class DealersCPFProvider extends BaseApi {

}
export const apiProvider = new DealersCPFProvider(DMS_MODULE, NAME);
